import type { IAudio } from "@src/types/AppTypes";
import { createContext } from "react";

export const MusicsContext = createContext<{
  musics: IAudio[];
  setMusics: React.Dispatch<{
    payload: IAudio[];
    type: "updateMusics";
  }>;
}>({ musics: [], setMusics: () => {} });

export function musicsReducer(
  state: IAudio[],
  action: { payload: IAudio[]; type: "updateMusics" }
) {
  if (action.type === "updateMusics") {
    return action.payload;
  } else {
    return state;
  }
}
